import { cn } from "src/utils/common.helper"

const AppointmentSectionHeader = ({ icon, title, className }) => {
  return (
    <div
      className={cn(
        "gap-2 flex flex-col md:flex-row items-center font-bold text-xs md:text-sm text-[--primary-blue] border-b-4 grow border-[--primary-blue] px-2 py-4 md:p-4",
        className
      )}
    >
      {icon}
      <div>{title} </div>
    </div>
  )
}

export default AppointmentSectionHeader
